import React, { useState, useEffect } from "react";
import "./Checkout.css";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faWallet } from "@fortawesome/free-solid-svg-icons";
import Order_summery_holder from "../cart/order_summery_holder/Order_summery_holder";
import Success_Modal from "../common-components/common-modals/success_modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import New_Address_Modal from "../common-components/common-modals/new_address_modal/New_Address_Modal";
import Logout_Modal from "../common-components/common-modals/logout_modal/Logout_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrder,
  deleteAddress,
  getAllOrderAddress,
  PaymentOnline,
} from "../../features/order/orderSlice";
import { OrderCalculation } from "../../features/order/orderSlice";
import { getAllCart } from "../../features/cart/cartSlice";
import useRazorpay from "react-razorpay";
import Edit_Address_Modal from "../common-components/common-modals/new_address_modal/Edit_Address_Modal";
import Common_breadcrumb from "../common-components/common-breadcrumb/Common_breadcrumb";
import Common_Back_Header from "../common-components/common_back_header/Common_Back_Header";
const Checkout = () => {
  const [successmodal, setSuccessmodal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showEditAddressModal, setShowEditAddressModal] = useState(false);
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [GSTNumber, setGSTNumber] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const [deleteModal, setDeletemodal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [CouponData, setCouponData] = useState("");
  const [rewardData, setRewardData] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState(2);
  const [editId, setEditId] = useState();
  const orderSumary = useSelector((state) => state.order.orderCalculation);
  const allOrdersAddress = useSelector((state) => state.order.allOrdersAddress);
  useEffect(() => {
    dispatch(getAllOrderAddress());
  }, [dispatch]);

  useEffect(() => {
    if (allOrdersAddress && allOrdersAddress?.data?.length > 0) {
      setSelectedAddress(allOrdersAddress?.data[0]?.id);
    }
  }, [allOrdersAddress]);

  useEffect(() => {
    if (orderSumary) {
      setRewardData((prev) =>
        prev !== orderSumary?.order_summary?.reward_status
          ? orderSumary?.order_summary?.reward_status
          : prev,
      );
      setCouponData((prev) =>
        prev !== orderSumary?.order_summary?.coupon
          ? orderSumary?.order_summary?.coupon
          : prev,
      );
      setSelectedIds((prev) =>
        prev !== orderSumary?.order_summary?.selected_id
          ? orderSumary?.order_summary?.selected_id
          : prev,
      );
    }
  }, [orderSumary]);

  const OrderCalculationData = async (
    coupon_id = null,
    rewardData,
    selectedIds,
  ) => {
    const data = {};
    if (coupon_id) {
      data.coupon_id = coupon_id;
    }
    if (selectedIds && selectedIds.length > 0) {
      data.selected_id = selectedIds;
    }
    if (rewardData) {
      data.reward_status = rewardData;
    }
    const res = await dispatch(OrderCalculation(data));
  };

  useEffect(() => {
    OrderCalculationData(CouponData?.id, rewardData, selectedIds);
  }, [rewardData, selectedIds]);

  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const [error, setError] = useState("");

  // const handleRazorpay = async (price,data) => {
  //   const amountInPaise = Math.round(price * 100);
  //   const options = {
  //     key: "rzp_test_I05KCFb1v5JJRc",
  //     amount: amountInPaise,
  //     currency: "INR",
  //     name: "Bapat Optics",
  //     description: "Test Transaction",
  //     image:
  //       "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

  //     handler: async (res) => {
  //       await setRazorId(res.razorpay_payment_id);
  //       // finalFunction(res.razorpay_payment_id);

  //       PaymentOnlineCreate()
  //     },
  //     prefill: {
  //       name: "Piyush Garg",
  //       email: "youremail@example.com",
  //       contact: "9999999999",
  //     },
  //     notes: {
  //       address: "Razorpay Corporate Office",
  //     },
  //     theme: {
  //       color: "#052c65",
  //     },
  //   };

  //   const rzpay = new Razorpay(options);
  //   rzpay.open();
  // };
  const user = useSelector((state) => state.user.userInfo);

  // const handleRazorpay = async (price, data) => {
  //   const amountInPaise = Math.round(1 * 100);

  //   const options = {
  //     key: "rzp_live_SNB1tPItlEwAsY",
  //     amount: amountInPaise,
  //     currency: "INR",
  //     name: "Bapat Optics",
  //     description: "Test Transaction",

  //     handler: async (res) => {
  //       await setRazorId(res.razorpay_payment_id);

  //       await PaymentOnlineCreate({
  //         order_id: data.id,
  //         payment_id: res.razorpay_payment_id,
  //       });
  //     },
  //     modal: {
  //       ondismiss: async function() {
  //         console.log("❌ Payment Popup Closed");
  //         setLoder(false);
  //       },
  //     },

  //     prefill: {
  //       name: user?.name,
  //       email: user?.email,
  //       contact: user?.contact_no,
  //     },

  //     notes: {
  //       order_id: data?.razorpay_order_id,
  //       address: "Razorpay Corporate Office",
  //     },

  //     theme: {
  //       color: "#052c65",
  //     },
  //   };

  //   const rzpay = new Razorpay(options);
  //   rzpay.open();
  // };

  const handleRazorpay = async (price, data) => {
    const amountInPaise = Math.round(Number(price) * 100);

    const options = {
      // key: "rzp_test_I05KCFb1v5JJRc",
      key: "rzp_live_SNB1tPItlEwAsY",
      amount: amountInPaise,
      currency: "INR",
      name: "Bapat Optics",
      description: "Order Payment",
      order_id: data?.razorpay_order_id,

      handler: async function(res) {
        try {
          await PaymentOnlineCreate({
            order_id: data.id,
            razorpay_payment_id: res.razorpay_payment_id,
            // razorpay_order_id: res.razorpay_order_id,
            // razorpay_signature: res.razorpay_signature,
          });
        } catch (err) {
          console.log(err);
        }
      },

      modal: {
        ondismiss: function() {
          console.log("❌ Payment Popup Closed");
          setLoder(false);
        },
      },

      prefill: {
        name: user?.name,
        email: user?.email,
        contact: user?.contact_no,
      },

      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new window.Razorpay(options);
    rzpay.open();
  };

  const isSignin = useSelector((state) => state.auth.is_signin);
  const [loder, setLoder] = useState("");
  const finalFunction = async (razorpay) => {
    setLoder(true);
    const datafinal = {
      address_id: selectedAddress,
      payment_method_id: paymentMethod,
      gst_number: GSTNumber,
      order_summary: orderSumary?.order_summary,
      order_Details_summary: orderSumary?.order_Details_summary,
    };
    if (razorpay) {
      datafinal.payment_id = razorpay;
    }

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      // if (Number(paymentMethod) === 2) {

      const amount = parseFloat(orderSumary?.order_summary?.total_amount);
      const orderData = res?.payload?.data;
      await handleRazorpay(amount, orderData);
      // }
      // setLoder(false);
      // setSuccessmodal(true);
      // setTimeout(() => {
      //   setSuccessmodal(false);
      //   navigate("/");
      // }, 1000);
      // await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      setLoder(false);
      if (res.payload.errors) {
        setError(res.payload.errors);
      }
    }
  };

  const [errorMessage, setErrorMessage] = useState("");
  const handleClick = () => {
    if (!allOrdersAddress?.data || allOrdersAddress.data.length === 0) {
      setErrorMessage("Please add an address before proceeding to checkout.");
      return;
    }
    if (Number(paymentMethod) === 1) {
      finalFunction();
    } else {
      finalFunction();
      // handleRazorpay(parseFloat(orderSumary?.order_summary?.total_amount));
    }
    setErrorMessage("");
    // setSuccessmodal(true);
    // setTimeout(() => {
    //   setSuccessmodal(false);
    //   navigate("/");
    // }, 2000);
  };

  const DeleteAdrress = async (id) => {
    const res = await dispatch(deleteAddress({ id: id }));

    if (res.meta?.requestStatus === "fulfilled") {
      // props?.onHide();
      await dispatch(getAllOrderAddress());

      setDeletemodal(true);
      setTimeout(() => {
        setDeletemodal(false);
      }, 2000);
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const PaymentOnlineCreate = async (data) => {
    const res = await dispatch(
      PaymentOnline({
        id: data.order_id,
        payment_id: data.razorpay_payment_id,
      }),
    );

    if (res.meta?.requestStatus === "fulfilled") {
      setLoder(false);
      setSuccessmodal(true);
      await dispatch(getAllCart(isSignin));
      setTimeout(() => {
        setSuccessmodal(false);
        navigate("/");
      }, 1000);
    }
  };

  //  const PaymentOnlineCreate = async (id, payment_id) => {

  //   console.log(payment_id,"payment_id payment_id");

  //   const res = await dispatch(PaymentOnline({ id: id, payment_id }));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     // props?.onHide();
  //     setLoder(false);
  //     setSuccessmodal(true);
  //     // setTimeout(() => {
  //     //   setSuccessmodal(false);
  //     //   navigate("/");
  //     // }, 1000);
  //     await dispatch(getAllCart(isSignin));
  //   } else if (res.meta?.requestStatus === "rejected") {
  //   }
  // };
  return (
    <section className="Checkout">
      {/*<Common_breadcrumb
        items={[
          { label: "Home", link: "/" },
          { label: "Collection", link: "/all-products" },
          { label: "Cart", link: "/cart" },
          { label: "Checkout" },
        ]}
      />*/}
      <div className="container ">
        <Common_Back_Header backNavigation="/cart" />
        <div className="row justify-content-center mt-3">
          <div className="col-xxl-9 col-lg-8">
            <div className="left_side_div">
              <div className="white_card_holder">
                <div className="top_holder">
                  <p className="card_title">Shipping Address</p>
                  <p
                    className="add_address_btn"
                    onClick={() => {
                      setShowAddressModal(true);
                    }}
                  >
                    Add Address
                  </p>
                </div>

                <div className="address_holder">
                  <div className="row">
                    {allOrdersAddress?.data?.map((item) => {
                      return (
                        <div className="col-xxl-4 col-md-6 ">
                          <div
                            className={`address_card ${
                              selectedAddress === item?.id ? "active" : ""
                            }`}
                          >
                            <div className="top_div">
                              <Form.Check
                                type="radio"
                                label={item?.Address_Type?.name}
                                name="address"
                                onChange={() => setSelectedAddress(item?.id)}
                                checked={selectedAddress === item?.id}
                              />

                              <div className="icons_holder">
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="inner_icon"
                                  onClick={() => {
                                    setEditId(item?.id);
                                    setShowEditAddressModal(true);
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  onClick={() => {
                                    DeleteAdrress(item?.id);
                                  }}
                                  // onClick={() => {
                                  //   setshowLogoutModal(true);
                                  // }}
                                  className="inner_icon"
                                />
                              </div>
                            </div>

                            <p className="address_text">
                              {item?.floor}, {item?.building}, {item?.direction}
                              ,{item?.street}
                              {item?.Users_Address_Detail?.City?.name} -{" "}
                              {item?.Users_Address_Detail?.Pincode?.name}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              {/* <div className="white_card_holder">
                <p className="card_title">Pay On Delivery</p>

                <div className="address_holder">
                  <div className={`address_card ${1 ? "active" : ""}`}>
                    <div className="option_holder">
                      <Form.Check
                        type="radio"
                        label=""
                        name="wallet"
                        onChange={() => setPaymentMethod(1)}
                        checked={paymentMethod === 1}
                      />
                      Pay On Delivery
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="white_card_holder">
                <p className="card_title">Online</p>

                <div className="address_holder">
                  <div className={`address_card ${2 ? "active" : ""}`}>
                    <div className="option_holder">
                      <Form.Check
                        type="radio"
                        label=""
                        name="wallet"
                        onChange={() => setPaymentMethod(2)}
                        checked={paymentMethod === 2}
                      />
                      Online
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-8">
            <Order_summery_holder
              GSTNumber={GSTNumber}
              setGSTNumber={setGSTNumber}
              errorMessage={errorMessage}
              Checkout={true}
              address={allOrdersAddress?.data}
              error={error}
              rewardData={rewardData}
              setRewardData={setRewardData}
              btnText="Pay Now"
              handleClick={handleClick}
              orderSumary={orderSumary}
            />
          </div>
        </div>
      </div>
      {loder && (
        <div className="loader_holder">
          <div className="spinner"></div>
        </div>
      )}

      <New_Address_Modal
        setErrorMessage={setErrorMessage}
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
      />

      {/* <New_Address_Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
      /> */}

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Order Purchase Succesfully"}
      />

      <Edit_Address_Modal
        Id={editId}
        show={showEditAddressModal}
        onHide={() => setShowEditAddressModal(false)}
      />
      <Success_Modal
        show={deleteModal}
        onHide={() => setDeletemodal(false)}
        successText={"Address Delete Succcessfully !"}
      />

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setshowLogoutModal(false)}
        questionText="Are you sure you want to delete this address?"
      />
    </section>
  );
};

export default Checkout;
